/**
 * This file specifies the state of the application in response to Compliance actions
 */

import { fromJS } from 'immutable';
import Constants from '../../constants';

const { Vendor, User } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  users: [],
  vendors: [],
  count: 0,
  vendorCount: 0,
});

/**
 * Returns and sets the next state based on the action passed to it
 *
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const complianceReducer = (state = initialState, action) => {
  const { count, users, user, vendors, error } = action;

  switch (action.type) {
    case User.GET_USERS:
      return state.set('loading', true);
    case User.GET_USERS_ERROR:
      return state.set('loading', false).set('error', error);
    case User.GET_USERS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('users', fromJS(users))
        .set('count', count);
    case Vendor.GET_VENDORS:
      return state.set('loading', true);
    case Vendor.GET_VENDORS_ERROR:
      return state.set('loading', false).set('error', error);
    case Vendor.GET_VENDORS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendorCount', count)
        .set('vendors', fromJS(vendors));
    case User.UPDATE_USER:
      return state.set('loading', true);
    case User.UPDATE_USER_ERROR:
      return state.set('loading', false).set('error', error);
    case User.UPDATE_USER_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(
          [
            'users',
            `${state.get('users').findIndex((v) => v.get('id') === user.id)}`,
          ],
          fromJS(user),
        );
    default:
      return state;
  }
};

export default complianceReducer;
